import { ProgramBundleInfoDetails } from "@modules/programBundle/components/programBundleInfoDetails"
import { ProgramBundleInfoHeader } from "@modules/programBundle/components/programBundleInfoHeader"
import { ProgramBundleInfoPrograms } from "@modules/programBundle/components/programBundleInfoPrograms"
import { useProgramBundle } from "@modules/programBundle/hooks/useProgramBundle"
import { ProgramBundleInfoSubscribersList } from "@modules/programBundle/programBundleSubscribers/components/programBundleInfoSubscribersList"
import { useSidebar } from "@modules/sidebar/hooks/useSidebar"
import { ErrorCard } from "@modules/ui/components/error/errorCard"
import { LoadingSpinner } from "@modules/ui/components/loading"

type ProgramBundleInfoResumeProps = {
  programBundleId: string
  editionAllowed: boolean
}

export enum ProgramBundleDetailsTabs {
  DETAILS,
  PROGRAMS,
  MEMBERS,
}

export const ProgramBundleInfoResume: React.FC<ProgramBundleInfoResumeProps> = ({
  programBundleId,
  editionAllowed,
}) => {
  const { data: programBundle, isLoading } = useProgramBundle(programBundleId)
  const { setCurrentStackState, getCurrentStackState } = useSidebar()

  const activeIndex = getCurrentStackState("activeIndex") || ProgramBundleDetailsTabs.DETAILS

  if (isLoading) return <LoadingSpinner />
  if (!programBundle) return <ErrorCard />

  return (
    <div className="flex flex-column flew-grow-1">
      <ProgramBundleInfoHeader
        programBundle={programBundle}
        activeIndex={activeIndex}
        setActiveIndex={(value: number) => setCurrentStackState("activeIndex", value)}
        editionAllowed={editionAllowed}
      />

      {activeIndex === ProgramBundleDetailsTabs.MEMBERS ? (
        <ProgramBundleInfoSubscribersList programBundle={programBundle} />
      ) : activeIndex === ProgramBundleDetailsTabs.PROGRAMS ? (
        <ProgramBundleInfoPrograms programBundle={programBundle} />
      ) : (
        <ProgramBundleInfoDetails programBundle={programBundle} />
      )}
    </div>
  )
}
